export default "__VITE_ASSET__DZkKKD9x__"